/**
 * cbpFWTabs.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * https://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2014, Codrops
 * http://www.codrops.com
 *
 * Note: This code has been modified from its original
 * format.
 */

(function (window) {
  "use strict";

  function extend(a, b) {
    for (let key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }
    return a;
  }

  function IWWTabs(e, options) {
    this.e = e;
    this.options = extend({}, this.options);
    extend(this.options, options);
    this._init();
  }

  IWWTabs.prototype.options = {
    start: 0,
  };

  IWWTabs.prototype._init = function () {
    // Selectors
    this.tabs = [].slice.call(this.e.querySelectorAll(".tabs > .tab-nav > li"));
    this.items = [].slice.call(this.e.querySelectorAll(".tabs > article"));

    // Current Tab
    this.current = -1;
    this._show();

    // Initialize Events
    this._initEvents();
  };

  IWWTabs.prototype._initEvents = function () {
    let self = this;
    this.tabs.forEach(function (tab, x) {
      tab.addEventListener("mouseover", function (evt) {
        evt.preventDefault();
        self._show(x);
      });
      tab.addEventListener("touchend", function (evt) {
        evt.preventDefault();
        self._show(x);
      });
    });
  };

  IWWTabs.prototype._show = function (x) {
    if (this.current >= 0) {
      this.tabs[this.current].className = this.items[this.current].className =
        "";
    }
    // Change Current Tab
    this.current =
      x !== undefined
        ? x
        : this.options.start >= 0 && this.options.start < this.items.length
        ? this.options.start
        : 0;

      try {
          this.tabs[this.current].className = "tab-current";
          this.items[this.current].className = "content-current";
      } catch(e) {
          // tried to access invalid tabs. do nothing, page probably failed to
          // load, so there will be an error displayed from that.
      }
  };

  // Add to Global Namespace
  window.IWWTabs = IWWTabs;
})(window);

// Initialize Function
(function () {
  [].slice.call(document.querySelectorAll(".tabs")).forEach(function (el) {
    new IWWTabs(el);
  });
})();
